import { render, staticRenderFns } from "./FichaEstructura.vue?vue&type=template&id=5c718608"
import script from "./FichaEstructura.vue?vue&type=script&lang=js"
export * from "./FichaEstructura.vue?vue&type=script&lang=js"
import style0 from "./FichaEstructura.vue?vue&type=style&index=0&id=5c718608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports